<template>
  <roe-error-message :field="design.initial_deferral_rate_autoenroll">
    <roe-percent-input
      v-model="design.$model.initial_deferral_rate_autoenroll"
    ></roe-percent-input>
    <label class="input-label-inside">%</label>
  </roe-error-message>
</template>

<script>
import RoeErrorMessage from "@/components/_shared/inputs/ErrorMessage";
import RoePercentInput from "@/components/_shared/inputs/PercentInput";
import { AutoEnrollmentMixin } from "@/components/_shared/inputs/design/_mixins";
export default {
  name: "RoeAutoEnrollmentInitialPercentInput",
  components: { RoePercentInput, RoeErrorMessage },
  mixins: [AutoEnrollmentMixin],
  props: {
    design: Object
  }
};
</script>
